__turbopack_context__.v({
  "container": "view-module__ZxjCKa__container",
  "containerLink": "view-module__ZxjCKa__containerLink",
  "star": "view-module__ZxjCKa__star",
  "titleHeading": "view-module__ZxjCKa__titleHeading",
  "titleLink": "view-module__ZxjCKa__titleLink",
});
